import { IStepNavigationContext } from "components/StepNavigation";
import { INewsletterContext } from "components/Modals/ModalConfig/core/modalConfig.types";
import { setUserData } from "redux/user/user.actions";
import { AppThunkDispatch } from "redux/configuration/configuration.types";

export const saveEmailAndContinue = async (
  stepNavigationContext: IStepNavigationContext,
  setEmail: INewsletterContext["setEmail"] | undefined,
  tempEmail: string,
  companyId: string,
  dispatch: AppThunkDispatch
): Promise<boolean> => {
  const saved = await dispatch(
    setUserData({ email: tempEmail, cpid: companyId })
  );
  if (!saved) {
    return false;
  }

  setEmail(tempEmail);
  stepNavigationContext.nextStep();
  return true;
};
